import api from '../../config/index'

const logoutUser = async (username) => {
    const response = await api.get(`Authentication/Logout/${username}`);
    return response.data;
}

const loginUser = async (data) => {
    const response = await api.post('Authentication/AuthenticateLogin', data);
    return response
}

const userToken = async (data) => {
    const response = await api.post('Authentication/AuthenticateMToken', data);
    return response.data;
}

const adminLogin = async (data) => {
  const response = await api.post('Authentication/AuthenticateAdminLogin', data)
  return response.data
}

const adminToken = async (data) => {
  const response = await api.post('Authentication/AuthenticateMAdminToken', data)
  return response.data
}

const userDetails = async (userId) => {
    const response = await api.get(`UserAPI/GetSingleUserDetailsById/${userId}`)
    return response.data
}


const AuthService = {
    logoutUser,
    loginUser,
    userToken,
    adminLogin,
    adminToken,
    userDetails
}

export default AuthService;

